import { render, staticRenderFns } from "./TextView.vue?vue&type=template&id=35d06dc8&scoped=true&"
import script from "./TextView.vue?vue&type=script&lang=ts&"
export * from "./TextView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d06dc8",
  null
  
)

export default component.exports